import { useConnection } from "@solana/wallet-adapter-react";
import { PublicKey } from "@solana/web3.js";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";

import { useWalletInfo } from "contexts/WalletInfoContext";
import { getUsersVoteRecord } from "services/marinade/sdk";

export const useUsersVoteRecords = () => {
  const { connection } = useConnection();
  const { walletAddress } = useWalletInfo();
  const [isLoadingOnChainData, setIsLoadingOnChainData] = useState(false);

  const query = useQuery(
    ["UsersVoteRecords", walletAddress?.toString()],
    async () => {
      return getUsersVoteRecord(connection, walletAddress ?? PublicKey.default);
    },
    {
      enabled: !!walletAddress,
      staleTime: 1000 * 60 * 10,
    }
  );

  useEffect(() => {
    if (walletAddress) {
      query.refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walletAddress, query.refetch]);

  useEffect(() => {
    if (!query.data?.address) return () => {};

    const subscriptionId = connection.onAccountChange(
      query.data.address,
      async () => {
        await query.refetch();
        setIsLoadingOnChainData(false);
      }
    );

    return () => {
      connection.removeAccountChangeListener(subscriptionId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.data?.address, query.refetch, connection]);

  return { ...query, isLoadingOnChainData, setIsLoadingOnChainData };
};
